import { AccountClientGroupRecord } from '@tassat/fred-definitions';
import { ActionTypes } from '@tassat/ui-definitions';

import { IErrorValues, IFormValues } from './types';
import {
    textFieldCharacterWhitelist,
    validateACGchars,
    validateAlphaNumeric,
    validateNoExcelFormulaStartingCharacters,
    validateNoLeadingZero
} from '../helpers/validationHelpers';

export const validateAddAcgNumberForm = (
    values,
    opts: {
        activeAcgs: AccountClientGroupRecord[];
        actionType: ActionTypes;
        initialValues: IFormValues;
    }
) => {
    const {
        activeAcgs,
        actionType,
        initialValues
    } = opts;

    const errors: IErrorValues = {} as IErrorValues;

    const acgName = values.ACGName.trim();
    const initialAcgName = initialValues.ACGName?.trim();

    if (!acgName) {
        errors.ACGName = 'ACG Name required';
    } else if (actionType === ActionTypes.add || (actionType === ActionTypes.edit && initialAcgName !== acgName)) {
        const doesAcgNameAlreadyExists = activeAcgs.some((acg) => acg.ACGName.toLowerCase() === acgName.toLowerCase());
        const acgNameExcelError = validateNoExcelFormulaStartingCharacters(acgName);
        const acgNameCharacterCheck = validateACGchars(acgName);

        if (acgNameExcelError) errors.ACGName = acgNameExcelError;
        else if (doesAcgNameAlreadyExists) errors.ACGName = 'ACG Name already exists, please enter a different value';
        else if (acgNameCharacterCheck) errors.ACGName = acgNameCharacterCheck;

        const acgNameWhitelistCheckError = textFieldCharacterWhitelist(acgName);

        if (acgNameWhitelistCheckError) errors.ACGName = acgNameWhitelistCheckError;
    }

    if (actionType === ActionTypes.add) {
        const acgNumber = values.ACGNumber.trim();
        const doesAcgNumberExist = activeAcgs.some(acg => acg.ACGNumber.toLowerCase() === acgNumber.toLowerCase());
        const alphaNumericError = validateAlphaNumeric(acgNumber);
        const leadingZeroError = validateNoLeadingZero(acgNumber);

        if (!values.ACGNumber) errors.ACGNumber = 'ACG Number required';
        else if (doesAcgNumberExist) errors.ACGNumber = 'ACG Number already exists, please enter a different value';
        else if (alphaNumericError) errors.ACGNumber = alphaNumericError;
        else if (leadingZeroError) errors.ACGNumber = leadingZeroError;
    }

    return errors;
};